'use strict';

var $carousel = $('.js-spotlight-carousel'),
	$carouselBelt,
	$carouselArrowRight,
	$carouselArrowLeft,
	$counterState,
	$counterLength;

if (!$carousel.length) return;


$carouselBelt  = $carousel.find('.js-spotlight-belt');
$carouselArrowLeft  = $carousel.find('.js-arrow-left');
$carouselArrowRight  = $carousel.find('.js-arrow-right');


$counterLength = $carousel.find('.js-counter-length');


$carouselBelt.slick({
  slide: '.js-carousel-slide',
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: $carouselArrowLeft,
  nextArrow: $carouselArrowRight,
  responsive: [
    {
      breakpoint: 800,
      settings: {
      	slidesToShow: 2,
      	slidesToScroll: 1,
      }
	  },
    {
      breakpoint: 560,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ],
});